export default "__VITE_ASSET__BhnOLROp__"